import { render, staticRenderFns } from "./peopleFilter.vue?vue&type=template&id=472e9bcc&scoped=true"
import script from "./peopleFilter.vue?vue&type=script&lang=js"
export * from "./peopleFilter.vue?vue&type=script&lang=js"
import style0 from "./peopleFilter.vue?vue&type=style&index=0&id=472e9bcc&prod&lang=scss&scoped=true"
import style1 from "./peopleFilter.vue?vue&type=style&index=1&id=472e9bcc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "472e9bcc",
  null
  
)

export default component.exports